import { createSelector } from 'reselect';
import ReceptacleTransportOverviewColumns from '../../containers/ReceptacleTransportOverviewColumns';
import ReportDefinitions from '../../../../../../common/config/ReportDefinitions';

export const getGeneratedOnDateTime = state => state
  .reporting.RECEPTACLE_TRANSPORT_OVERVIEW.metadata.generatedOnDateTime;

export const getIsLoading =
  state => state.reporting.RECEPTACLE_TRANSPORT_OVERVIEW.isLoading;

export const getData =
  ReportDefinitions.RECEPTACLE_TRANSPORT_OVERVIEW.getDataFunction();

export const getColumns =
  createSelector(getData, ReceptacleTransportOverviewColumns);
